import React, { useState, useRef, useEffect } from 'react';

export default function EditableLabel({ value, onSave }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value);
  const inputRef = useRef(null);

  // Reset edit mode and draft whenever the underlying value changes (e.g. sheet switch).
  useEffect(() => {
    setEditing(false);
    setDraft(value);
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const commit = () => {
    setEditing(false);
    if (draft.trim() && draft.trim() !== value) onSave(draft.trim());
    else setDraft(value);
  };

  const cancel = () => {
    setEditing(false);
    setDraft(value);
  };

  if (editing) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
        <input
          ref={inputRef}
          value={draft}
          onChange={e => setDraft(e.target.value)}
          onBlur={commit}
          onKeyDown={e => { if (e.key === 'Enter') commit(); if (e.key === 'Escape') cancel(); }}
          style={{ flex: 1, fontSize: 13, padding: '2px 4px', border: '1px solid #0d6efd', borderRadius: 4 }}
        />
        <button
          onMouseDown={e => { e.preventDefault(); cancel(); }}
          title="Cancel"
          style={{ background: 'none', border: 'none', padding: '0 2px', cursor: 'pointer', color: '#6c757d', fontSize: 16, lineHeight: 1, flexShrink: 0 }}
        >×</button>
      </div>
    );
  }

  return (
    <span
      onClick={() => setEditing(true)}
      title="Click to edit label"
      style={{ cursor: 'pointer', display: 'block' }}
    >
      {value}
      <i className="bi bi-pencil" style={{ marginLeft: 6, color: '#0d6efd', fontSize: 10, opacity: 0.6 }} />
    </span>
  );
}
